class CrossfadeHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.crossfade-hero__slide'));
    this.dots   = Array.from(this.querySelectorAll('.crossfade-hero__dot'));
    this.current = 0;
    this.interval  = parseInt(this.dataset.interval,  10) || 5000;
    this.transition = parseInt(this.dataset.transition, 10) || 1000;

    this.style.setProperty(
      '--fade-duration',
      (this.transition / 1000) + 's'
    );

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    if (this.slides.length > 1) this.startTimer();
  }

  goTo(n) {
    this.slides[this.current].classList.remove('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');
    this.current = (n + this.slides.length) % this.slides.length;
    this.slides[this.current].classList.add('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
  }

  startTimer() {
    clearInterval(this._timer);
    this._timer = setInterval(() => {
      this.goTo(this.current + 1);
    }, this.interval);
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }
}

customElements.define('crossfade-hero', CrossfadeHero);

document.querySelectorAll('.crossfade-hero').forEach(el => {
  if (!customElements.get('crossfade-hero')) return;
  const instance = Object.create(CrossfadeHero.prototype);
  instance.connectedCallback = CrossfadeHero.prototype.connectedCallback;
  instance.goTo = CrossfadeHero.prototype.goTo;
  instance.startTimer = CrossfadeHero.prototype.startTimer;
  Object.assign(el, instance);
  instance.connectedCallback.call(el);
});
